<template>
  <!-- 遮罩层 -->
  <div class="modal-backdrop" v-if="isShow" @click="handleBackdropClick"></div>

  <!-- 弹窗容器：垂直+水平居中 -->
  <div class="support-modal" v-if="isShow">
    <div class="close-btn" @click="handleClose"><img src="@/assets/images/icons/icon_lianxiwomen_back@3x.png" alt=""></div>
    <h2 class="modal-title"> <span style="font-weight: 550;">Matrix Power</span> {{ $t('home.TechnicalSupport') }}</h2>
    <input 
      type="email" 
      class="email-input" 
      :placeholder="$t('home.EmailInput')"
      v-model="emailValue"
      @input="handleInput"
      @blur="validateEmailFormat"
    >
    <!-- 错误提示：邮箱格式不正确时显示 -->
    <p style="font-size: 12px;margin-bottom:5px ;" >{{ $t('home.attention') }}</p>
    <p class="error-tip" v-if="showErrorTip">{{ errorTipText }}</p>
    <button 
      class="contact-btn" 
      @click="handleContact"
      :disabled="!emailValue.trim() || showErrorTip" >
      {{ $t('home.contact') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SupportModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: 'Matrix Power 技术支持'
    },
    contactBtnText: {
      type: String,
      default: '联系我们'
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      emailValue: '',
      showErrorTip: false, // 是否显示错误提示
      errorTipText:this.$t('home.emailFormat') // 错误提示文本
    }
  },
  watch: {
    // 输入变化时，自动隐藏错误提示
    emailValue(newVal) {
      if (newVal.trim()) {
        this.showErrorTip = false;
      }
    },
    // 弹窗隐藏时重置状态
    isShow(newVal) {
      if (!newVal) {
        this.emailValue = '';
        this.showErrorTip = false;
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close-modal');
    },
    // 点击联系按钮：先校验格式，再触发父组件事件
    handleContact() {
      const email = this.emailValue.trim();
      // 再次校验（防止绕过输入框直接点击）
      if (this.validateEmail(email)) {
        this.$emit('contact', email);
        this.emailValue = ''; // 成功后清空输入
        this.showErrorTip = false;
      } else {
        this.showErrorTip = true; // 格式错误显示提示
      }
    },
    handleInput(val) {
      this.$emit('input', val);
    },
    // 邮箱格式校验正则（支持大部分常见邮箱格式，包括带特殊字符的）
    validateEmail(email) {
      const reg = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}$/;
      return reg.test(email);
    },
    // 失去焦点时校验格式
    validateEmailFormat() {
      const email = this.emailValue.trim();
      if (email && !this.validateEmail(email)) {
        this.showErrorTip = true;
      }
    },
    handleBackdropClick() {
      if (this.closeOnBackdrop) {
        this.handleClose();
      }
    }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}

/* 弹窗容器 */
.support-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  box-sizing: border-box;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  border-color: #666;
  color: #333;
}

/* 标题 */
.modal-title {
  text-align: center;
  font-size: 18px;
  color: #333;
  margin: 10px 0 30px;
}

/* 输入框 */
.email-input {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 6px;
  background-color: #F0F0F0;
  padding: 0 15px;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px; /* 减少底部间距，给错误提示留位置 */
  box-sizing: border-box;
  outline: none;
  transition: background-color 0.3s ease;
}

.email-input::placeholder {
  color: #99a4b3;
}

.email-input:focus {
  background-color: #E8E8E8;
}

/* 错误提示 */
.error-tip {
  color: #F56C6C; /* 红色提示 */
  font-size: 12px;
  margin: 0 0 20px 0; /* 上0下20，与按钮保持间距 */
  text-align: left;
  height: 16px; /* 固定高度，防止布局跳动 */
}

/* 按钮：重点优化禁用状态 */
.contact-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 6px;
  background-color: #FFD200;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.contact-btn:hover:not(:disabled) {
  background-color: #FFC107; /*  hover 时加深黄色 */
}

/* 禁用状态：背景色 #BFBFBF，文字灰色 */
.contact-btn:disabled {
  background-color: #BFBFBF !important; /* 优先级确保生效 */
  color: #888888;
  cursor: not-allowed;
  box-shadow: none;
}

/* 响应式适配 */
@media (max-width: 480px) {
  .support-modal {
    width: 90%;
    padding: 15px;
  }
  
  .contact-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>